import $ from 'jquery';
import { onPageLoad } from '@/js/modules/page_load';

onPageLoad(() => {
  if ($('body').is('#legacy-upgrade')) {
    $(window).scroll(() => {
      const headerHeight = $('.header').height();
      const filterContainerHeight = $('.all-features-dropdown__tabs').innerHeight();
      const filtersDistanceToTopOfWindow = document
        .getElementsByClassName('all-features-dropdown__tabs-anchor')[0]
        .getBoundingClientRect().top;
      const designDistanceToTopOfWindow = document
        .getElementById('accordion-dropdown__section--design')
        .getBoundingClientRect().top;
      const colaborateDistanceToTopOfWindow = document
        .getElementById('accordion-dropdown__section--collaborate')
        .getBoundingClientRect().top;
      const manageDistanceToTopOfWindow = document
        .getElementById('accordion-dropdown__section--manage')
        .getBoundingClientRect().top;
      const getPaidDistanceToTopOfWindow = document
        .getElementById('accordion-dropdown__section--get-paid')
        .getBoundingClientRect().top;
      const getSectionPadding = parseInt(
        window
          .getComputedStyle(document.getElementsByClassName('accordion-dropdown__section')[1], null)
          .getPropertyValue('padding-top')
      );
      const getSectionMargin = parseInt(
        window
          .getComputedStyle(document.getElementsByClassName('accordion-dropdown__section')[1], null)
          .getPropertyValue('margin-top')
      );

      if (filtersDistanceToTopOfWindow <= headerHeight) {
        $('.all-features-dropdown__tabs-anchor').css('height', `${filterContainerHeight}px`);
        $('.all-features-dropdown__tabs').css('top', `${headerHeight}px`);
        $('.all-features-dropdown').addClass('all-features-dropdown--anchored');
      } else {
        $('.all-features-dropdown__tabs').css('top', '0');
        $('.all-features-dropdown__tabs-anchor').height(0);
        $('.all-features-dropdown').removeClass('all-features-dropdown--anchored');
      }

      if (
        designDistanceToTopOfWindow -
          filterContainerHeight -
          headerHeight +
          getSectionPadding +
          getSectionMargin <=
        headerHeight
      ) {
        $('.all-features-dropdown__tab').removeClass('all-features-dropdown__tab--active');
        $('.all-features-dropdown__tab--design').addClass('all-features-dropdown__tab--active');
      }
      if (
        colaborateDistanceToTopOfWindow -
          filterContainerHeight -
          headerHeight +
          getSectionPadding +
          getSectionMargin <=
        headerHeight
      ) {
        $('.all-features-dropdown__tab').removeClass('all-features-dropdown__tab--active');
        $('.all-features-dropdown__tab--collaborate').addClass(
          'all-features-dropdown__tab--active'
        );
      }
      if (
        manageDistanceToTopOfWindow -
          filterContainerHeight -
          headerHeight +
          getSectionPadding +
          getSectionMargin <=
        headerHeight
      ) {
        $('.all-features-dropdown__tab').removeClass('all-features-dropdown__tab--active');
        $('.all-features-dropdown__tab--manage').addClass('all-features-dropdown__tab--active');
      }
      if (
        getPaidDistanceToTopOfWindow -
          filterContainerHeight -
          headerHeight +
          getSectionPadding +
          getSectionMargin <=
        headerHeight
      ) {
        $('.all-features-dropdown__tab').removeClass('all-features-dropdown__tab--active');
        $('.all-features-dropdown__tab--get-paid').addClass('all-features-dropdown__tab--active');
      }
      if (
        getPaidDistanceToTopOfWindow -
          filterContainerHeight +
          getSectionPadding +
          getSectionMargin -
          headerHeight * 2 <=
        0
      ) {
        $('.all-features-dropdown__tabs').css(
          'translate',
          `0 ${
            getPaidDistanceToTopOfWindow -
            filterContainerHeight +
            getSectionPadding +
            getSectionMargin -
            headerHeight * 2
          }px`
        );
      } else {
        $('.all-features-dropdown__tabs').css('translate', '0 0');
      }
    });
  }

  $(document).on('click', '.all-features-dropdown__tab', (e) => {
    const headerHeight = $('.header').height();
    const scrollToFeature = $(e.currentTarget).data('target');
    const tagtetStyle = window.getComputedStyle(document.getElementById(scrollToFeature), null);
    const filterContainerHeight = $('.all-features-dropdown__tabs').innerHeight();
    const element = document.getElementById(scrollToFeature);
    const paddingTop = parseInt(tagtetStyle.getPropertyValue('padding-top'));
    const marginTop = parseInt(tagtetStyle.getPropertyValue('margin-top'));
    const scrollDistance =
      element.getBoundingClientRect().top +
      window.scrollY -
      headerHeight -
      filterContainerHeight +
      paddingTop +
      marginTop -
      headerHeight +
      1;
    window.scroll({
      top: scrollDistance,
      behavior: 'smooth',
    });
  });

  // add source of the video with autoplay parameter when mdal opens
  // and remove it after modal closes
  // to previent autoplay triggering in the closed modal
  $(document).on('click', '.legacy-promo-info__video', () => {
    $('#video-legacy-pomo')
      .find('.video-modal__iframe')
      .attr('src', 'https://www.youtube.com/embed/YxV_raPDYXA?rel=0&autoplay=1');
  });
  $(document).on($.modal.CLOSE, '#video-legacy-pomo', () => {
    $('#video-legacy-pomo').find('.video-modal__iframe').attr('src', '');
  });
});
